import { FC } from "react";
import { TbPlaneArrival, TbPlaneDeparture } from "react-icons/tb";
import { SegmentType } from "src/Modules/Flights/constants";
import type { Segment } from "src/Modules/Flights/constants/JourneyResult";
import { SegmentBody, SegmentHeader } from "../../../JourneyDetails/Steps/Details/components/SegmentCard/components";

const FlightSegmentCard: FC<{ segment: SegmentType; segmentNumber: number }> = ({ segment, segmentNumber }) => {
  const isReturn = segmentNumber > 0;

  return (
    <div className="bg-background-default overflow-hidden rounded-md shadow-sm">
      <div className="bg-background-default border-border-subtle flex items-center gap-3 border-b px-6 py-4">
        <div className="bg-background-primary-lighter text-font-active flex size-10 shrink-0 items-center justify-center rounded-md text-xl">
          {isReturn ? <TbPlaneArrival /> : <TbPlaneDeparture />}
        </div>
        <div className="min-w-0 flex-1">
          <SegmentHeader segment={segment} segmentNumber={segmentNumber} />
        </div>
      </div>
      <div className="md:p-6 px-3 py-2">
        <SegmentBody segment={segment} />
      </div>
    </div>
  );
};

const FlightSegments: FC<{ segments?: Segment[] }> = ({ segments = [] }) => {
  return (
    <div className="flex w-full flex-col gap-4">
      {segments.map((segment, index) => (
        <FlightSegmentCard key={`segment-${index}`} segment={segment as unknown as SegmentType} segmentNumber={index} />
      ))}
    </div>
  );
};

export default FlightSegments;
